import { useRefreshCoilStore } from '@/coils/stores/refreshCoilStore';
import { useRefreshProductionOrderStore } from '@/productionOrders/stores/refreshProductionOrderStore';
import { useRefereshProductStore } from '@/products/commands/refreshProductStore';
import { useRefreshSettingStore } from '@/settings/stores/refreshSettingStore';
import { useRefreshShapeStore } from '@/shapes/stores/refreshShapeStore';
import { useRefreshStorageAreaStore } from '@/storageAreas/stores/refreshStorageAreaStore';
import { useRefreshVehicleStore } from '@/vehicles/stores/refreshVehicleStore';

export function useRefreshState() {
  const refreshProductStore = useRefereshProductStore();
  const refreshSettingStore = useRefreshSettingStore();
  const refreshShapeStore = useRefreshShapeStore();
  const refreshStorageAreaStore = useRefreshStorageAreaStore();
  const refreshVehicleStore = useRefreshVehicleStore();
  const refreshCoilStore = useRefreshCoilStore();
  const refreshProductionOrderStore = useRefreshProductionOrderStore();

  async function initialize() {
    refreshProductStore.initialize();
    refreshShapeStore.initialize();
    refreshSettingStore.initialize();
    refreshStorageAreaStore.initialize();
    refreshCoilStore.initialize();
    refreshVehicleStore.initialize();
    refreshProductionOrderStore.initialize();
  }

  async function refresh() {
    await refreshProductStore.refresh();
    await refreshShapeStore.refresh();
    await refreshSettingStore.refresh();
    await refreshStorageAreaStore.refresh();
    await refreshCoilStore.refresh();
    await refreshVehicleStore.refresh();
    await refreshProductionOrderStore.refresh();
  }

  return {
    initialize,
    refresh,
  };
}
